import { Ammo } from '../physics'
import state from '../state'
import * as THREE from 'three'
import { createRigidBody } from './utils'

export default function createBall(pos, quat) {
  const ball = new THREE.Mesh(
    new THREE.SphereBufferGeometry(state.objects.ball.radius, 20, 20),
    new THREE.MeshPhongMaterial({ color: 0x202020 }),
  )
  ball.castShadow = true
  ball.receiveShadow = true

  const ballShape = new Ammo.btSphereShape(state.objects.ball.radius)
  ballShape.setMargin(state.physics.margin)
  pos.set(-3, 2, 0)
  quat.set(0, 0, 0, 1)
  createRigidBody(ball, ballShape, state.objects.ball.mass, pos, quat)
  ball.userData.physicsBody.setFriction(0.5)

  return ball
}
